<div class="container-xl my-6">
  <a
    [routerLink]="['/category', category.categoryId]"
    title="Go to the Help Center home page"
    ><i class="material-icons-round">chevron_left</i>Back to
    {{ category.categoryTitle }}</a
  >
  <div class="row mt-7">
    <div class="col-sm-8">
      <h3 class="mt-0 mb-5" [innerHTML]="questionOne.question"></h3>
      <div [innerHTML]="questionOne.answer"></div>
      <h3 class="mt-7" *ngIf="getRelatedLinks().length > 0">Related Links</h3>
      <p *ngFor="let linkId of getRelatedLinks()">
        <a (click)="goToSelectedLink(linkId)" class="related-link text-dark"
          ><u [innerHTML]="getRelatedLinkContent(linkId)"></u></a
        >
      </p>
      <h3 class="mt-7">Didn't find what you need?</h3>
      <p>
        <a
          href="{{isRegisteredUser ? 'https://www.labcorp.com/contact-us/labcorp-patient-portal' : 'https://www.labcorp.com/help/contact-info-for-patient/patient-portal-inquiry'}}"
          target="_blank"
          >Contact us for help</a
        >
      </p>
    </div>
    <div class="col-sm-3 offset-sm-1">
      <app-more-topics></app-more-topics>
    </div>
  </div>
</div>
